import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import bookingCodePrefixApi from '@/features/dashboard/bookingCodePrefix/api/bookingCodePrefixApi.ts';
import { bookingCodePrefixApiQueryKeys } from '@/features/dashboard/bookingCodePrefix/api/bookingCodePrefixApi.queryKeys.ts';
import { BookingCodePrefixDto } from '@/features/dashboard/bookingCodePrefix/types/BookingCodePrefixDto.ts';

export default function useSetBookingCodePrefix() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: BookingCodePrefixDto) => bookingCodePrefixApi.set(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: bookingCodePrefixApiQueryKeys.all(),
      });
      toast.success('Prefiks numeru rezerwacji został zapisany');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message ||
          'Wystąpił błąd podczas zapisywania prefiksu numeru rezerwacji.',
      });
    },
  });
}
